import { Component } from "react";
import {
  Container,
  Navbar,
  Nav,
  NavDropdown,
  Form,
  Button,
} from "react-bootstrap";
import { TopLogo } from "./MultipleComp";
// import behtarlogo from "../../public/img/behtarBrokerNewTag.png"
// import CallBackModal from "./ReactModal";
import $ from "jquery";
// import { withTranslation } from "react-i18next";
import { withTranslation } from "react-i18next";

import { withRouter, Link } from "react-router-dom";
import { FRONT_BASE_URL, HEADER_AUTH } from "./App";

import { ReactSearchAutocomplete } from "react-search-autocomplete";
import api from "../helpers/api";
class Header extends Component {
  constructor(props, context) {
    super(props, context);
    this.state = {
      languages: [],
      suggestion: [],
      blogsuggestion: [],
      search: "",
      alias: "",
      investorsuggestion: [],
      contentsuggestion: [],
      currentPath: window.location.pathname,
    };

    this.debouncedSearch = this.debounce(this.searchApi, 500);
  }

  debounce = (func, delay) => {
    let timer;
    return (...args) => {
      clearTimeout(timer);
      timer = setTimeout(() => {
        func.apply(this, args);
      }, delay);
    };
  };

  componentDidMount() {
    const location = this.state.currentPath;
    let language = location.split("/")[1];
    if (language == "gu" || language == "hi" || language == "mr") {
      const currentLang = language;
      const { i18n } = this.props;
      i18n.changeLanguage(currentLang);
      localStorage.setItem("title", currentLang == "en" ? "English" : "हिन्दी");
      localStorage.setItem("language_id", currentLang == "en" ? "0" : "1");
    }

    // ================== FIX START ==================
    // let url = "basic/get_search_result?searchKey=&searchsubmit=Search";

    // if (!(localStorage.getItem("language_id") === "0" || localStorage.getItem("language_id") === 0)) {
    //   url += `&language=${localStorage.getItem("language_id")}`;
    // }

    // api
    //   .get(url)
    //   .then((res) => {
    //     const result = res.data || {};
    //     this.setState({
    //       suggestion: result.data?.productData || [],
    //       blogsuggestion: result.data?.blogData || [],
    //       investorsuggestion: result.data?.investorData || [],
    //       contentsuggestion: result.data?.contentData || [],
    //     });
    //   })
    //   .catch((err) => {
    //     console.error("Search API error:", err);
    //   });
    // ================== FIX END ==================

    if (!localStorage.getItem("language_id")) {
      localStorage.setItem("language_id", 0);
    }

    $(".search-ico").click(function () {
      $(this).toggleClass("active");
      $(".search-form").toggleClass("show");
    });

    $(window).scroll(function () {
      if ($(document).scrollTop() > 20) {
        $("#header").addClass("is-fixed");
      } else {
        $("#header").removeClass("is-fixed");
      }
    });

    // Get languages
    api
      .get("basic/get_languages")
      .then((res) => {
        this.setState({ languages: res.data?.result || [] });
      })
      .catch((error) => console.log("Language fetch error:", error));
  }

  searchApi = (searchKey) => {
    let url = `basic/get_search_result?searchKey=${searchKey}&searchsubmit=Search`;

    if (
      !(localStorage.getItem("language_id") === "0" ||
        localStorage.getItem("language_id") === 0)
    ) {
      url += `&language=${localStorage.getItem("language_id")}`;
    }

    api
      .get(url)
      .then((res) => {
        const result = res.data || {};
        this.setState({
          suggestion: result.productData ? result.productData : [],
          blogsuggestion: result.blogData ? result.blogData : [],
          investorsuggestion: result.investorData ? result.investorData : [],
          contentsuggestion: result.contentData ? result.contentData : [],
        });
      })
      .catch((err) => {
        console.error("Search API error:", err);
      });
  };



  // changeLanguageInUrl = (newLang) => {
  //   const { history, location } = this.props;

  //   // Regular expression to match the language part of the URL
  //   const languageRegex = /^\/(en|hi|gu|mr)(\/|$)/;

  //   let newPath;

  //   if (languageRegex.test(location.pathname)) {
  //     // If the URL contains a language, replace it
  //     newPath = location.pathname.replace(languageRegex, `/${newLang}$2`);
  //   } else {
  //     // If the URL does not contain a language, prepend the new language
  //     newPath = `/${newLang}${location.pathname}`;
  //   }

  //   history.push(newPath);
  // };

  render() {
    // const location = useLocation();
    // console.log('location:', window.location.pathname);

    if (window.location.href.toString().split("/")[3] !== "") {
      $("meta[name='twitter:card']").remove();
      $("meta[name='twitter:site']").remove();
      $("meta[name='twitter:title']").remove();
      $("meta[name='twitter:description']").remove();
      $("meta[property='og:title']").remove();
      $("meta[property='og:site_name']").remove();
      $("meta[property='og:url']").remove();
      $("meta[property='og:description']").remove();
      $("meta[property='og:type']").remove();
    }

    let items = [];

    this.state?.suggestion?.map((data) => {
      items.push({
        name: data.purpose + " " + data.product,
        id: "detail/" + data.slug,
      });
    });
    this.state?.blogsuggestion?.map((data) => {
      items.push({
        name: data.blog_title,
        id: "blog/" + data.category_alias + "/" + data.alias,
      });
    });
    this.state?.investorsuggestion?.map((data) => {
      items.push({
        name: data.title + " " + data.assessment_year,
        id:
          data.alias === "policies-and-codes"
            ? data.alias
            : "investor-relations/" + data.alias,
      });
    });
    this.state?.contentsuggestion?.map((data) => {
      items.push({ name: data.title, id: data.alias });
    });

    const handleOnSearch = (string) => {
      this.setState({ search: string });

      if (string.length >= 3) {
        this.debouncedSearch(string);
      } else {
        // Clear suggestions if less than 3 chars
        this.setState({
          suggestion: [],
          blogsuggestion: [],
          investorsuggestion: [],
          contentsuggestion: [],
        });
      }
    };

    const handleOnChange = (e) => {
      this.setState({
        search: e.target.value,
      });
    };
    const formatResult = (item) => {
      return (
        <>
          <span
            onMouseDownCapture={() => {
              window.location.href = FRONT_BASE_URL + "/" + item?.id;
              // this.props.history.push(`${item?.id}`);
            }}
            style={{
              display: "block",
              textAlign: "left",
              whiteSpace: "pre-wrap",
            }}
          >
            {item.name}
          </span>
        </>
      );
    };
    withRouter(formatResult);

    const { t, i18n } = this.props;
    const changeLanguage = (newLang) => {
      // this.changeLanguageInUrl(newLang);
      i18n.changeLanguage(newLang);
    };
    let { languages } = this.state;

    return (
      <>
        <header id="header" className="header">
          <nav expand="sm" className="d-flex nav-secondary bg-primary">
            <Container>
              <Nav className="d-flex justify-content-end">
                <Link to="/about-us" className="nav-link">
                  {t("about_us")}
                </Link>
                <Link to="/careers" className="nav-link">
                  {t("careers")}
                </Link>
                <Link to="/investor-relations" className="nav-link">
                  {t("investor_relations")}
                </Link>
                <Link to="/faqs" className="nav-link">
                  {t("FAQs")}
                </Link>
                <Link to="/contact-us" className="nav-link">
                  {t("contact_us")}
                </Link>
                <Link to="/locate-us" className="nav-link">
                  {t("Locate Us")}
                </Link>
                <select
                  className="form-control form-control-sm mr-lg-3 mr-2 language-select"
                  value={localStorage.getItem("title") || "English"}
                  onChange={(e) => {
                    const selectedValue = e.target.value;

                    if (selectedValue === "English") {
                      changeLanguage("en");
                      localStorage.setItem("title", "English");
                      localStorage.setItem("language_id", 0);
                    } else {
                      const selectedLang = languages.find(
                        (lan) => lan.languages === selectedValue
                      );

                      if (selectedLang) {
                        changeLanguage(selectedLang.language_code);
                        localStorage.setItem("title", selectedLang.languages);
                        localStorage.setItem("language_id", selectedLang.id);
                      }
                    }

                    window.location.reload();
                  }}
                >
                  <option value="English">English</option>

                  {languages.map((lan) => (
                    <option key={lan.id} value={lan.languages}>
                      {lan.languages}
                    </option>
                  ))}
                </select>
              </Nav>
            </Container>
          </nav>

          <Container>
            <Navbar expand="xl" className="nav-primary">
              <Navbar.Brand href="/">
                <TopLogo />
              </Navbar.Brand>
              <Navbar.Toggle aria-controls="basic-navbar-nav" />
              <Navbar.Collapse id="basic-navbar-nav">
                <Nav className="mr-auto">
                  <Link to="/housing-loans" className="nav-link">
                    {t("Housing Loans")}
                  </Link>
                  <Link to="/non-housing-loans" className="nav-link">
                    {t("Non Housing Loans")}
                  </Link>
                  <Link to="/construction-finance" className="nav-link">
                    {t("Construction Finance")}
                  </Link>
                  <Link to="/calculators" className="nav-link">
                    {t("calculators")}
                  </Link>
                  <Link to="/blog" className="nav-link">
                    {t("Blog")}
                  </Link>
                  <Link to="/auction-property" className="nav-link">
                    {t("Properties on Auction")}
                  </Link>
                  <div className="behtar-broker">
                    <Link to="/homeverse" className="nav-link" style={{ color: "#CD1F28" }}>
                      {t("HomeVerse")}
                    </Link>
                    {/* <img src="../img/Frame.svg" alt="Behtar Broker" />
                     */}

                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="12"
                      height="12"
                      viewBox="0 0 12 12"
                      fill="none"
                      className="behtar-broker-new"
                    >
                      <g clipPath="url(#clip0_251_45)">
                        <path
                          d="M11.3181 5.11251C11.1334 4.97634 10.9028 4.80624 10.8725 4.69354C10.8396 4.56989 10.957 4.29911 11.052 4.08155C11.2148 3.70797 11.3828 3.32085 11.196 2.99893C11.0077 2.67285 10.5845 2.62484 10.176 2.57894C9.94277 2.55284 9.65269 2.52051 9.56606 2.43337C9.47893 2.34623 9.44659 2.05616 9.4205 1.82345C9.37459 1.41493 9.3271 0.992323 9.00051 0.803445C8.71669 0.638584 8.29616 0.782584 7.91789 0.947445C7.7092 1.03823 7.4911 1.12483 7.30538 1.12693C7.19268 1.09668 7.02313 0.866054 6.88641 0.681358C6.65166 0.362079 6.38503 0 5.99999 0C5.61546 0 5.34834 0.362079 5.11302 0.681383C4.97634 0.866592 4.80676 1.09722 4.6471 1.13216C4.50623 1.13216 4.29023 1.03825 4.08155 0.947469C3.70225 0.782608 3.28121 0.640173 2.99947 0.803469C2.67234 0.992347 2.62487 1.41496 2.57894 1.82399C2.55284 2.05721 2.52051 2.34677 2.43389 2.43391C2.34675 2.52051 2.05667 2.55338 1.82397 2.57896C1.41493 2.62487 0.991785 2.67288 0.803445 2.99895C0.617184 3.32087 0.785176 3.70748 0.947445 4.08157C1.04241 4.29914 1.16031 4.57043 1.12693 4.69408C1.09668 4.80678 0.866592 4.97687 0.681358 5.11305C0.362079 5.34783 0 5.61494 0 5.99999C0 6.38503 0.362079 6.65217 0.681921 6.88746C0.866616 7.02364 1.09722 7.19373 1.12749 7.30643C1.16036 7.43008 1.04297 7.70086 0.948008 7.91843C0.785225 8.292 0.617233 8.67912 0.804008 9.00104C0.992347 9.32712 1.41549 9.37513 1.82402 9.42104C2.05723 9.44713 2.34731 9.47946 2.43394 9.5666C2.52107 9.65374 2.55341 9.94382 2.5795 10.1765C2.62541 10.585 2.6729 11.0077 2.99949 11.1965C3.28175 11.3609 3.70228 11.2174 4.08157 11.0525C4.29026 10.9617 4.50469 10.8694 4.69408 10.873C4.80678 10.9033 4.97634 11.1339 5.11305 11.3186C5.34834 11.6379 5.61497 12 6.00001 12C6.38454 12 6.65166 11.6379 6.88698 11.3186C7.02366 11.1334 7.19325 10.9028 7.3529 10.8673C7.49377 10.8673 7.70977 10.9612 7.91845 11.052C8.2988 11.2169 8.71879 11.3598 9.00053 11.1965C9.32766 11.0077 9.37513 10.585 9.42106 10.176C9.44716 9.94279 9.47949 9.65323 9.56611 9.56609C9.65325 9.47895 9.94333 9.44662 10.176 9.42052C10.5851 9.37462 11.0082 9.32712 11.1966 9.00053C11.3828 8.67861 11.2148 8.292 11.0526 7.91791C10.9576 7.70035 10.8402 7.42905 10.8731 7.30591C10.9033 7.19322 11.1334 7.02312 11.3186 6.88695C11.6379 6.65217 12 6.38503 12 5.99999C12 5.61494 11.6379 5.34783 11.3181 5.11251ZM4.69565 7.04347C4.69565 7.15565 4.62365 7.25529 4.51721 7.29078C4.49009 7.30017 4.46243 7.30435 4.43477 7.30435C4.39428 7.30431 4.35435 7.29486 4.31814 7.27675C4.28192 7.25864 4.25041 7.23236 4.22608 7.19999L3.13043 5.73913V7.04347C3.13043 7.18747 3.01356 7.30435 2.86956 7.30435C2.72556 7.30435 2.60868 7.18747 2.60868 7.04347V4.95653C2.60868 4.84434 2.68068 4.74471 2.78711 4.70922C2.89303 4.67322 3.01094 4.71027 3.07824 4.8L4.17389 6.26086V4.95653C4.17389 4.81253 4.29077 4.69565 4.43477 4.69565C4.57877 4.69565 4.69565 4.81253 4.69565 4.95653V7.04347ZM6.52174 5.73913C6.66574 5.73913 6.78262 5.85601 6.78262 6.00001C6.78262 6.14401 6.66574 6.26086 6.52174 6.26086H5.73914V6.7826H6.52174C6.66574 6.7826 6.78262 6.89947 6.78262 7.04347C6.78262 7.18747 6.66574 7.30435 6.52174 7.30435H5.47826C5.33426 7.30435 5.21738 7.18747 5.21738 7.04347V4.95653C5.21738 4.81253 5.33426 4.69565 5.47826 4.69565H6.52174C6.66574 4.69565 6.78262 4.81253 6.78262 4.95653C6.78262 5.10053 6.66574 5.2174 6.52174 5.2174H5.73914V5.73913H6.52174ZM9.9052 5.01965L9.38347 7.10659C9.36982 7.16139 9.33872 7.21026 9.29487 7.24583C9.25101 7.2814 9.19678 7.30175 9.14035 7.30381H9.12991C9.07511 7.30381 9.0217 7.28658 8.97723 7.25456C8.93275 7.22254 8.89947 7.17735 8.88209 7.12538L8.60869 6.30312L8.33478 7.12592C8.29826 7.23548 8.20799 7.30905 8.07703 7.30384C7.9612 7.29965 7.86208 7.2188 7.83391 7.10662L7.31218 5.01967C7.27774 4.87985 7.36226 4.73845 7.50208 4.7035C7.63931 4.66801 7.78331 4.75307 7.81826 4.8934L8.12242 6.11114L8.36085 5.39584C8.43233 5.18297 8.78502 5.18297 8.85597 5.39584L9.0944 6.11114L9.39856 4.8934C9.433 4.75305 9.57387 4.66853 9.71474 4.7035C9.85565 4.73842 9.94018 4.88034 9.9052 5.01965Z"
                          fill="#DEBC00"
                        />
                      </g>
                      <defs>
                        <clipPath id="clip0_251_45">
                          <rect width="12" height="12" fill="white" />
                        </clipPath>
                      </defs>
                    </svg>
                  </div>
                </Nav>
              </Navbar.Collapse>
              <div className="right-navbar">
                <Nav className="ms-auto align-items-center">
                  {/* {!window.location.href.includes("landing/home-loan") && !window.location.href.includes("landing/non-housing-loan") ? (

                  <CallBackModal />
                  ):''
                }  */}

                  {/* <CallBackModal hidesidebar={this.props.hidesidebar} /> */}

                  <a
                    href="/instant-loan-approval/1"
                    className="user-ico btn-loan btn btn-secondary mr-2"
                  >
                    {t("Instant Loan Approval")}
                  </a>

                  <NavDropdown
                    title={
                      localStorage.getItem("title")
                        ? localStorage.getItem("title")
                        : "English"
                    }
                    id="basic-nav-dropdown"
                    className="language-ico mr-lg-3 mr-2 btn btn-outline"
                  >
                    <NavDropdown.Item
                      className="dropdown-item-en"
                      onClick={() => {
                        changeLanguage("en");
                        localStorage.setItem("title", "English");
                        localStorage.setItem("language_id", 0);
                        window.location.reload();
                      }}
                    >
                      English
                    </NavDropdown.Item>
                    {languages.map((lan, i) => {
                      return (
                        <NavDropdown.Item
                          className={
                            lan.id == 1
                              ? "dropdown-item-hi"
                              : lan.id == 2
                                ? "dropdown-item-gu"
                                : lan.id == 3
                                  ? "dropdown-item-ma"
                                  : "dropdown-item-en"
                          }
                          key={i}
                          onClick={() => {
                            changeLanguage(lan.language_code);
                            localStorage.setItem("title", lan.languages);
                            localStorage.setItem("language_id", lan.id);
                            window.location.reload();
                          }}
                        >
                          {lan.languages}
                        </NavDropdown.Item>
                      );
                    })}
                  </NavDropdown>
                  <a href="#" className="search-ico ml-0">
                    Search
                  </a>

                  {/* <div className="search-form">
                    <Form action="/search" method="GET" id="searchform">
                      <Form.Group controlId="formSearch">
                        <ReactSearchAutocomplete
                          items={items}
                          placeholder={t("Search here...")}
                          onSearch={handleOnSearch}
                          autoFocus
                          formatResult={formatResult}
                          name="searchKey" // important for form GET
                        />
                        <Button
                          type="submit"
                          id="searchsubmit"
                          disabled={!this.state.search} // simpler
                          name="searchsubmit"
                          value="Search"
                        >
                          <img src="../img/search-ico.png" alt="Search" />
                        </Button>
                      </Form.Group>
                    </Form>

                  </div> */}
                  <div className="search-form">
                    <Form action="/search" method="GET" id="searchform">
                      <Form.Group controlId="formSearch">
                        <Form.Control
                          type="text"
                          hidden
                          onChange={handleOnChange}
                          value={this.state.search}
                          placeholder={t("Search here...")}
                          name="searchKey"
                        />
                        <ReactSearchAutocomplete
                          items={items}
                          placeholder={t("Search here...")}
                          onSearch={handleOnSearch}
                          autoFocus
                          formatResult={formatResult}
                        />
                        <Button
                          variant="submit"
                          id="searchsubmit"
                          disabled={this.state?.search === "" ? true : false}
                          name="searchsubmit"
                          type="submit"
                          value="Search"
                        >
                          <img src="../img/search-ico.png" alt="Search" />
                        </Button>
                      </Form.Group>
                    </Form>
                  </div>
                </Nav>
              </div>
            </Navbar>
          </Container>
        </header>
      </>
    );
  }
}

export default withRouter(withTranslation()(Header));
// export default withTranslation()(Header);
